var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.69645 6.99836C9.33559 6.99836 10.6644 5.66957 10.6644 4.03043C10.6644 2.39129 9.33559 1.0625 7.69645 1.0625C6.0573 1.0625 4.72852 2.39129 4.72852 4.03043C4.72852 5.66957 6.0573 6.99836 7.69645 6.99836Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.67775 8.18058L8.39025 10.3711L8.14904 8.97643C8.3434 8.97643 8.50088 8.46903 8.50088 8.27506V8.15868C8.50088 7.9651 8.3434 7.80762 8.14904 7.80762H7.24334C7.04937 7.80762 6.89265 7.9651 6.89265 8.15868V8.27506C6.89265 8.46903 7.04937 8.97643 7.24334 8.97643L7.00135 10.3711L5.71462 8.18058C4.25044 8.71371 2.53198 10.1214 2.66334 13.8134H7.69542H12.7294C12.8596 10.1214 11.1419 8.71371 9.67775 8.18058Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgent);
export default __webpack_public_path__ + "static/media/Agent.5b318be8cffdf7f2bb7b212ebf74c386.svg";
export { ForwardRef as ReactComponent };